import React from 'react';
import moment from 'moment';
import 'moment-timezone';

class FinishShiftHeader extends React.Component {

    render () {
        const shift = this.props.shift || {};
        const position = this.props.shift.position || {};
        let shift_start = null;
        if (typeof(shift.start_time) !== 'undefined') {
            shift_start = moment(shift.start_time).tz(shift.company.timezone).format('DD.MM.YYYY');
        }

        return (
            <header className="finish-shift-header">
                <div className="maxwidth-wrapper">
                    <h1 className="page-title">Finish up shift</h1>
                    <span className="page-description">{shift.workers_needed} {position.name} -  {shift.venue} - {shift_start}</span>
                </div>
            </header>
        );
    }
}

export default FinishShiftHeader;



/** WEBPACK FOOTER **
 ** ./app/src/components/FinishShiftHeader.js
 **/